import React, { useState, useEffect } from "react";

// propsTypes
import PropTypes from "prop-types";

// redux
import { connect } from "react-redux";

// libraries
import moment from "moment";
import { isEmpty, reject, filter, isEqual } from "lodash";
import Joi from "joi";
import { Label, Dropdown } from "semantic-ui-react";

// Actions
import genericAction from "@Actions/generic";

// Utils
import { dropdownFormat } from "@Utils/formats";

// components
import IKModal from "@Components/IkModal";
import Input from "@Components/Input";
import Text from "@Components/Text";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";

// styles
import styles from "./styles.module.css";

const AddHoliDay = ({ open, onClose, onSave, itemEditHoliDay, data, dispatch }) => {
	const [name, setName] = useState("");
	const [date, setDate] = useState("");
	const [startHour, setStartHour] = useState("");
	const [endHour, setEndHour] = useState("");
	const [messageDefault, setMessageDefault] = useState("");
	const [messageOptions, setMessageOptions] = useState([]);
	const [initialFormData, setInitialFormData] = useState({
		name: "",
		date: "",
		startHour: "",
		endHour: "",
		messageId: null,
	});

	const [message, setMessage] = useState({});
	const [openModal, setOpen] = useState(false);
	const [dataMessage, setDataMessage] = useState([]);
	const [errors, setErrors] = useState({
		name: "",
		date: "",
		startHour: "",
		endHour: "",
	});

	const schema = Joi.object({
		name: Joi.string().required().messages({
			"string.empty": "El Nombre es requerido",
		}),
		date: Joi.date().required().messages({
			"date.empty": "La Fecha es requerida",
			"date.base": "La Fecha es requerida",
		}),
	});

	useEffect(() => {
		(async () => {
			await getMessageOptions();
		})();
	}, []);

	useEffect(() => {
		if (!isEmpty(itemEditHoliDay)) {
			setName(itemEditHoliDay.name || "");
			setDate(itemEditHoliDay.date ? moment(itemEditHoliDay.date).format("YYYY-MM-DD") : "");
			setStartHour(itemEditHoliDay.startHour || "");
			setEndHour(itemEditHoliDay.endHour || "");
			setInitialFormData({
				name: itemEditHoliDay.name || "",
				date: itemEditHoliDay.date ? moment(itemEditHoliDay.date).format("YYYY-MM-DD") : "",
				startHour: itemEditHoliDay.startHour || "",
				endHour: itemEditHoliDay.endHour || "",
				messageId: itemEditHoliDay.messageId || null,
			});
		} else {
			setName("");
			setDate("");
			setStartHour("");
			setEndHour("");
			setInitialFormData({
				name: "",
				date: "",
				startHour: "",
				endHour: "",
				messageId: null,
			});
		}
	}, [itemEditHoliDay]);

	const getMessageOptions = async () => {
		const messagePromise = dispatch(genericAction({ method: "get", route: `presetMessages/all` }));
		const [messageResponse] = await Promise.all([messagePromise]);

		setDataMessage(messageResponse);

		const filteredMessages = filter(messageResponse, (item) => {
			return item.typeId === 10;
		});

		setMessageOptions(dropdownFormat(filteredMessages, "title", "id"));
	};

	const handleSelectMessage = (e, { value }) => {
		setMessageDefault(value);

		const messageObject = filter(dataMessage, (item) => {
			return item.id === value;
		});

		setMessage(messageObject[0]);
	};

	const handleSave = () => {
		const object = {
			name,
			date,
		};

		const validation = schema.validate(object, { abortEarly: false });
		if (validation.error) {
			const errorss = validation.error.details.reduce(
				(acc, item) => {
					acc[item.context.key] = item.message;
					return acc;
				},
				{
					name: "",
					userLimit: "",
					channels: "",
					sessionTimeout: "",
				}
			);

			setErrors(errorss);
			return;
		}

		if (isEmpty(itemEditHoliDay)) {
			// Creating a new holiday
			let parsedDate = moment();
			if (date && moment(date).isValid()) {
				parsedDate = moment(date);
			}

			let parsedStartHour = null;
			if (startHour) {
				const startMoment = moment(startHour, ["HH:mm", "HH:mm:ss"]);
				if (startMoment.isValid()) {
					parsedStartHour = startMoment;
				}
			}

			let parsedEndHour = null;
			if (endHour) {
				const endMoment = moment(endHour, ["HH:mm", "HH:mm:ss"]);
				if (endMoment.isValid()) {
					parsedEndHour = endMoment;
				}
			}

			const newData = {
				name,
				date: parsedDate.format("YYYY-MM-DD"),
				startHour: parsedStartHour ? parsedStartHour.format("HH:mm:ss") : null,
				endHour: parsedEndHour ? parsedEndHour.format("HH:mm:ss") : null,
				messageId: messageDefault || null,
				message,
			};

			onSave([...data, newData]);
			setName("");
			setDate("");
			setStartHour("");
			setEndHour("");
			onClose();
		} else {
			// Editing an existing holiday
			let parsedDate = moment();
			if (date && moment(date).isValid()) {
				parsedDate = moment(date);
			}

			let parsedStartHour = null;
			if (startHour) {
				const startMoment = moment(startHour, ["HH:mm", "HH:mm:ss"]);
				if (startMoment.isValid()) {
					parsedStartHour = startMoment;
				}
			}

			let parsedEndHour = null;
			if (endHour) {
				const endMoment = moment(endHour, ["HH:mm", "HH:mm:ss"]);
				if (endMoment.isValid()) {
					parsedEndHour = endMoment;
				}
			}

			const updatedData = {
				...itemEditHoliDay,
				name,
				date: parsedDate.format("YYYY-MM-DD"),
				startHour: parsedStartHour ? parsedStartHour.format("HH:mm:ss") : null,
				endHour: parsedEndHour ? parsedEndHour.format("HH:mm:ss") : null,
				messageId: messageDefault || null,
			};

			const resultData = reject(data, { id: itemEditHoliDay.id });

			onSave([...resultData, updatedData]);
			onClose();
		}
	};

	// modal
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		const currentFormData = {
			name,
			date,
			startHour,
			endHour,
			messageId: messageDefault || null,
		};
		if (isEqual(initialFormData, currentFormData)) {
			cancelModal();
		} else if (openModal) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	return (
		<>
			<IKModal
				open={open}
				onClose={modalOpen}
				onSuccess={handleSave}
				size="tiny"
				fullHeight
				title={isEmpty(itemEditHoliDay) ? "Agregar Feriado" : "Editar Feriado"}>
				<div className={styles.modalContent}>
					<div className={styles.content}>
						<Text className={styles.text}>
							Nombre:<span className={styles.required}>*</span>
						</Text>
						<Input
							name="name"
							placeholder="Ej. Día de la Constitución"
							required
							value={name}
							onChange={(e) => {
								setName(e.target.value);
							}}
						/>
						{!isEmpty(errors.name) && (
							<Label className={styles.messageError} pointing="above">
								{errors.name}
							</Label>
						)}
					</div>

					<div className={styles.contentDate}>
						<Text className={styles.text}>
							Fecha:<span className={styles.required}>*</span>
						</Text>
						<Input
							type="date"
							name="date"
							placeholder="Seleccione la fecha"
							value={date}
							min={moment().format("YYYY-MM-DD")}
							onChange={(e) => {
								setDate(e.target.value);
							}}
						/>
						{!isEmpty(errors.date) && (
							<Label className={styles.messageError} pointing="above">
								{errors.date}
							</Label>
						)}
					</div>

					<div className={styles.content2}>
						<div className={styles.content2Item}>
							<Text className={styles.text}>Hora Inicio: </Text>
							<Input
								name="startHour"
								type="time"
								placeholder="Ej. 08:00"
								value={startHour}
								onChange={(e) => {
									setStartHour(e.target.value);
								}}
							/>
							{!isEmpty(errors.startHour) && (
								<Label className={styles.messageError} pointing="above">
									{errors.startHour}
								</Label>
							)}
						</div>
						<div className={styles.content2Item}>
							<Text className={styles.text}>Hora Fin: </Text>
							<Input
								name="endHour"
								type="time"
								placeholder="Ej. 09:00"
								value={endHour}
								onChange={(e) => {
									setEndHour(e.target.value);
								}}
							/>
							{!isEmpty(errors.endHour) && (
								<Label className={styles.messageError} pointing="above">
									{errors.endHour}
								</Label>
							)}
						</div>
					</div>
					<div className={styles.contentDate}>
						<Text className={styles.text}>Mensaje Fuera de Horario: </Text>
						<Dropdown
							placeholder="Seleccione un mensaje"
							options={messageOptions}
							search
							selection
							fluid
							clearable
							value={messageDefault}
							allowAdditions
							onChange={handleSelectMessage}
						/>
						{!isEmpty(errors.messageDefault) && (
							<Label className={styles.messageError} pointing="above">
								{errors.messageDefault}
							</Label>
						)}
					</div>
				</div>
			</IKModal>
			{openModal && (
				<ConfirmModal
					visible
					header="Confirmar Cerrar"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
		</>
	);
};

AddHoliDay.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	itemEditHoliDay: PropTypes.object,
	data: PropTypes.array,
	dispatch: PropTypes.func,
};

export default connect()(AddHoliDay);
